import { render, staticRenderFns } from "./ViewAddressVerification.vue?vue&type=template&id=2668eaca&"
import script from "./ViewAddressVerification.vue?vue&type=script&lang=js&"
export * from "./ViewAddressVerification.vue?vue&type=script&lang=js&"
import style0 from "./ViewAddressVerification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports